import AbstractTemplateManager from "./templateManager";
import generatePath from './generatePath';
import { cssGlobalFilenameSuffix, cssTabletFilenameSuffix, cssMobileFilenameSuffix } from "../../../config/fileSuffixes";
import createTemplate from "./createTemplate";
import { definedPages } from "../../../config/defaults";

class InternalBuildTemplateManager extends AbstractTemplateManager {
    constructor() {
        super();
        this.cssGlobalTemplates = [];
        this.cssTabletTemplates = [];
        this.cssMobileTemplates = [];
        this.layoutPreloadJsInclude = ['<link rel="preload" href="js/js.js?v={{ lqTS }}" as="script">',
                                        '<link rel="preload" href="js/init-ui1.js?v={{ lqTS }}" as="script">',
                                        '<link rel="preload" href="js/init-ui2.js?v={{ lqTS }}" as="script">'];
        this.layoutJsInclude = [`<script src="js/js.js?v={{ lqTS }}"></script>`,
            `<script src="js/init-ui1.js?v={{ lqTS }}"></script>`,
            `<script src="js/init-ui2.js?v={{ lqTS }}"></script>`
        ];
        this.layoutPreloadCssInclude = {
            global: [`<link rel="preload" href="css/desktop1.css?v={{ lqTS }}" as="style">`,
                `<link rel="preload" href="css/desktop2.css?v={{ lqTS }}" as="style">`,
                `<link rel="preload" href="css/offline.css?v={{ lqTS }}" as="style">`,
                `{% if page.PageId == config.DefinedPages.Order.Id -%}
<link rel="preload" href="css/collection-points.css?v={{ lqTS }}" as="style">
{% endif -%}`],
            tablet: [],
            mobile: [`<link rel="preload" href="css/mobile.css?v={{ lqTS }}" media="(max-width: 1279px)" as="style">`]
        };
        this.layoutCssGlobalInclude = [`<link rel="stylesheet" href="css/desktop1.css?v={{ lqTS }}">`,
                                        `<link rel="stylesheet" href="css/desktop2.css?v={{ lqTS }}">`,
                                        `<link rel="stylesheet" href="css/offline.css?v={{ lqTS }}">`,
                                        `{% if page.PageId == config.DefinedPages.Order.Id -%}
    <link rel="stylesheet" href="css/collection-points.css?v={{ lqTS }}">
{% endif -%}`];
        this.layoutCssTabletInclude = [];
        this.layoutCssMobileInclude = [`<link rel="stylesheet" href="css/mobile.css?v={{ lqTS }}" media="(max-width: 1279px)">`];

        //TODO move it somewhere else
        this.firstIncludes = {
            js: [],
            css: [],
            cssTablet: [],
            cssMobile: [],
            generate(headerLocations, footerLocations) {
                if (headerLocations.js && footerLocations.js) {
                    this.js = [
                        // "js/" + baseLayout + ".js",
                        headerLocations.js,
                        footerLocations.js
                    ];   
                }
                if (headerLocations.css && footerLocations.css) {
                    this.css = [
                        // "css/" + baseLayout + cssGlobalFilenameSuffix + ".css",
                        headerLocations.css,
                        footerLocations.css
                    ];   
                }
                if (headerLocations.cssTablet && footerLocations.cssTablet) {
                    this.cssTablet = [
                        // "css/" + baseLayout + cssTabletFilenameSuffix + ".css",
                        headerLocations.cssTablet,
                        footerLocations.cssTablet
                    ];   
                }
                if (headerLocations.cssMobile && footerLocations.cssMobile) {
                    this.cssMobile = [
                        // "css/" + baseLayout + cssMobileFilenameSuffix + ".css",
                        headerLocations.cssMobile,
                        footerLocations.cssMobile
                    ];   
                }
            }
        }
    }

    //this kinda breaks the DRY rule but I want to keep it that way in case something needs to be changed
    generateCssGlobalTemplate(locationPrefix, location, templateObject) {
        let cssPrefix;
        if (!!locationPrefix) {
            cssPrefix = "css/" + locationPrefix;
        } else {
            cssPrefix = "css";
        }
        const fullPathCSS = generatePath(cssPrefix, location, templateObject.id || "", "css", cssGlobalFilenameSuffix);
        if (location === "header") {
            this.headerLocations.css = fullPathCSS;
        }
        if (location === "footer") {
            this.footerLocations.css = fullPathCSS;
        }

        if (this.templates.has(fullPathCSS)) { return; } //or throw, not sure
        const cssContent = templateObject.css || "";
        if (!Object.keys(templateObject).includes('css')) { return; }
        const template = createTemplate(fullPathCSS, cssContent);
        this.cssGlobalTemplates.push({
            pages: this.getTemplatePageNames(templateObject),
            path: fullPathCSS
        });
        this.templates.set(fullPathCSS, template);
    }

    //this kinda breaks the DRY rule but I want to keep it that way in case something needs to be changed
    generateCssMobileTemplate(locationPrefix, location, templateObject) {
        let cssPrefix;
        if (!!locationPrefix) {
            cssPrefix = "css/" + locationPrefix;
        } else {
            cssPrefix = "css";
        }
        const fullPathCSS = generatePath(cssPrefix, location, templateObject.id || "", "css", cssMobileFilenameSuffix);
        if (location === "header") {
            this.headerLocations.cssMobile = fullPathCSS;
        }
        if (location === "footer") {
            this.footerLocations.cssMobile = fullPathCSS;
        }

        if (this.templates.has(fullPathCSS)) { return; } //or throw, not sure
        const cssContent = templateObject.cssMobile || "";
        if (!Object.keys(templateObject).includes('cssMobile')) { return; }
        const template = createTemplate(fullPathCSS, cssContent);
        this.cssMobileTemplates.push({
            pages: this.getTemplatePageNames(templateObject),
            path: fullPathCSS
        });
        this.templates.set(fullPathCSS, template);
    }

    //this kinda breaks the DRY rule but I want to keep it that way in case something needs to be changed
    generateCssTabletTemplate(locationPrefix, location, templateObject) {
        let cssPrefix;
        if (!!locationPrefix) {
            cssPrefix = "css/" + locationPrefix;
        } else {
            cssPrefix = "css";
        }
        const fullPathCSS = generatePath(cssPrefix, location, templateObject.id || "", "css", cssTabletFilenameSuffix);
        if (location === "header") {
            this.headerLocations.cssTablet = fullPathCSS;
        }
        if (location === "footer") {
            this.footerLocations.cssTablet = fullPathCSS;
        }

        if (this.templates.has(fullPathCSS)) { return; } //or throw, not sure
        const cssContent = templateObject.cssTablet || "";
        if (!Object.keys(templateObject).includes('cssTablet')) { return; }
        const template = createTemplate(fullPathCSS, cssContent);
        this.cssTabletTemplates.push({
            pages: this.getTemplatePageNames(templateObject),
            path: fullPathCSS
        });
        this.templates.set(fullPathCSS, template);
    }

    getBaseLayout() {
        const baseLayoutObject = Object.assign({}, require("../../../assets/layout").default);
        const baseLayoutPath = baseLayoutObject.path;

        // almost like: this.generateObjectTemplate("", baseLayoutPath, baseLayoutObject);
        // but without calling this.generateJsTemplate(...)
        this.generateHtmlTemplate("", baseLayoutPath, baseLayoutObject);
        this.generateCssGlobalTemplate("", baseLayoutPath, baseLayoutObject);
        this.generateCssMobileTemplate("", baseLayoutPath, baseLayoutObject);
        this.generateCssTabletTemplate("", baseLayoutPath, baseLayoutObject);
        this.generateScssTemplate("", baseLayoutPath, baseLayoutObject, cssGlobalFilenameSuffix, "scss");
        this.generateScssTemplate("", baseLayoutPath, baseLayoutObject, cssTabletFilenameSuffix, "scssTablet");
        this.generateScssTemplate("", baseLayoutPath, baseLayoutObject, cssMobileFilenameSuffix, "scssMobile");

        this.layoutJs = baseLayoutObject.js;
    }

    generateFileCSSTemplate(templateName, firstIncludesCss, cssTemplates, [allowedPage, allowedPageName], layoutPreloadInclude, layoutCssInclude, additionalLinkSettings) {
        if (this.templates.has(templateName)) { return; }
        let css = "";
        if (!allowedPage) {
            firstIncludesCss.forEach(path => {
                css += `{% include '${path}' -%}\n`;
            });
        }
        cssTemplates.forEach(({ pages, path }) => {
            if (this.staticFilePaths.has(path)) { return; }
            if (firstIncludesCss.findIndex(value => value === path) !== -1) { return; }
            if (allowedPage) {
                pages.forEach(page => {
                    if (page === allowedPage) {
                        css += `{% include '${path}' -%}\n`;
                    }
                });
            }
            if (!allowedPage && pages.length === 0) {
                css += `{% include '${path}' -%}\n`;
            }
        });
        if (!css) { return; }
        const templateObj = createTemplate(templateName, css);
        this.templates.set(templateName, templateObj);
        let preloadLink = '';
        let stylesheetLink = '';
        if (allowedPage) {
            preloadLink += `{% if page.PageId == ${allowedPageName} -%}\n`;
            stylesheetLink += `{% if page.PageId == ${allowedPageName} -%}\n`;
        }
        preloadLink += `<link rel="preload" href="${templateName}?v={{ lqTS }}" ${additionalLinkSettings || ''} as="style">`;
        stylesheetLink += `<link rel="stylesheet" href="${templateName}?v={{ lqTS }}" ${additionalLinkSettings || ''} >`;
        if (allowedPage) {
            preloadLink += '\n{% endif -%}';
            stylesheetLink += '\n{% endif -%}';
        }
        layoutPreloadInclude.push(preloadLink);
        layoutCssInclude.push(stylesheetLink);
    }

    generateLayoutCSSGlobalTemplate() {
        this.generateFileCSSTemplate("css/layout/layout.css", 
                                    this.firstIncludes.css,
                                    this.cssGlobalTemplates, 
                                    [], 
                                    this.layoutPreloadCssInclude.global, 
                                    this.layoutCssGlobalInclude, 
                                    null
        );
        for (const [definedPage, definedPageName] of Object.entries(definedPages)) {
            this.generateFileCSSTemplate(`css/layout/layout-${definedPage.toLowerCase()}.css`,
                                    this.firstIncludes.css,
                                    this.cssGlobalTemplates,
                                    [definedPage, definedPageName],
                                    this.layoutPreloadCssInclude.global, 
                                    this.layoutCssGlobalInclude, 
                                    null
            );
        }
    }
    generateLayoutCSSTabletTemplate() {
        this.generateFileCSSTemplate(`css/layout/layout${cssTabletFilenameSuffix}.css`, 
                                    this.firstIncludes.cssTablet,
                                    this.cssTabletTemplates, 
                                    [], 
                                    this.layoutPreloadCssInclude.tablet, 
                                    this.layoutCssTabletInclude, 
                                    'media="screen and (min-width: 768px) and (max-width: 1439px)"'
        );
        for (const [definedPage, definedPageName] of Object.entries(definedPages)) {
            this.generateFileCSSTemplate(`css/layout/layout-${definedPage.toLowerCase()}${cssTabletFilenameSuffix}.css`,
                                    this.firstIncludes.cssTablet,
                                    this.cssTabletTemplates,
                                    [definedPage, definedPageName],
                                    this.layoutPreloadCssInclude.tablet,
                                    this.layoutCssTabletInclude,
                                    'media="screen and (min-width: 768px) and (max-width: 1439px)"'
            );
        }
    }
    generateLayoutCSSMobileTemplate() {
        this.generateFileCSSTemplate(`css/layout/layout${cssMobileFilenameSuffix}.css`,
                                    this.firstIncludes.cssMobile,
                                    this.cssMobileTemplates,
                                    [],
                                    this.layoutPreloadCssInclude.mobile,
                                    this.layoutCssMobileInclude,
                                    'media="screen and (max-width: 767px)"'
        );
        for (const [definedPage, definedPageName] of Object.entries(definedPages)) {
            this.generateFileCSSTemplate(`css/layout/layout-${definedPage.toLowerCase()}${cssMobileFilenameSuffix}.css`,
                                    this.firstIncludes.cssMobile,
                                    this.cssMobileTemplates,
                                    [definedPage, definedPageName],
                                    this.layoutPreloadCssInclude.mobile,
                                    this.layoutCssMobileInclude,
                                    'media="screen and (max-width: 767px)"'
            );
        }
    }

    generateLayoutTemplates(fontName = "Roboto") {
        const today = new Date();
        const options = { year: 'numeric', month: '2-digit', day: '2-digit'};
        const abstractFileVersion = today.toLocaleDateString(undefined, options) + '_' + today.toLocaleTimeString();
        const regexPattern = /\?v=.*?{{ lqTS }}/;
        const replaceVersion = '?v=' + abstractFileVersion + '_{{ lqTS }}'

        for (let i=0; i<this.layoutPreloadJsInclude.length; i++) {
            this.layoutPreloadJsInclude[i] = this.layoutPreloadJsInclude[i].replace(regexPattern, replaceVersion);
        }
        for(let i=0; i<this.layoutJsInclude.length; i++){
            this.layoutJsInclude[i] = this.layoutJsInclude[i].replace(regexPattern, replaceVersion);
        }
        for (let i=0; i<this.layoutPreloadCssInclude.global.length; i++) {
            this.layoutPreloadCssInclude.global[i] = this.layoutPreloadCssInclude.global[i].replace(regexPattern, replaceVersion);
        }
        for (let i=0; i<this.layoutPreloadCssInclude.tablet.length; i++) {
            this.layoutPreloadCssInclude.tablet[i] = this.layoutPreloadCssInclude.tablet[i].replace(regexPattern, replaceVersion);
        }
        for (let i=0; i<this.layoutPreloadCssInclude.mobile.length; i++) {
            this.layoutPreloadCssInclude.mobile[i] = this.layoutPreloadCssInclude.mobile[i].replace(regexPattern, replaceVersion);
        }
        for(let i=0; i<this.layoutCssGlobalInclude.length; i++){
            this.layoutCssGlobalInclude[i] = this.layoutCssGlobalInclude[i].replace(regexPattern, replaceVersion);
        }
        for(let i=0; i<this.layoutCssTabletInclude.length; i++){
            this.layoutCssTabletInclude[i] = this.layoutCssTabletInclude[i].replace(regexPattern, replaceVersion);
        }
        for(let i=0; i<this.layoutCssMobileInclude.length; i++){
            this.layoutCssMobileInclude[i] = this.layoutCssMobileInclude[i].replace(regexPattern, replaceVersion);
        }

        this.firstIncludes.generate(this.headerLocations, this.footerLocations);
        this.generateLayoutJSTemplate(false, abstractFileVersion);
        this.generateLayoutCSSGlobalTemplate();
        this.generateLayoutCSSTabletTemplate();
        this.generateLayoutCSSMobileTemplate();
        this.generateLayoutHTMLTemplate(fontName);
        this.layoutTemplatesReady = true;
    }
}

export default InternalBuildTemplateManager;